<template>
    <div class="row">
        <div class="col-12 d-flex flex-row align-items-center justify-content-between mb-4">
            <h1>{{ $t('tag-groups') }}</h1>
            <button class="btn btn-primary" @click="$router.push('/settings/taggroups/0')">
                <b-icon icon="plus" class="mr-1"/>{{  $t('new') }}
            </button>
        </div>

        <div class="col-12">
            <Table
                :data="tagGroups"
                :cols="cols"
                :loading="loading"
                :submitting="submitting"
                :filters="filters"
                @selectItem="item => this.$router.push(`/settings/taggroups/${item.id}`)"
            />
        </div>
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue"

export default {
    components: {
        Table,
    },
    mounted() {
        this.fetchTagGroups().then(() => { this.loading = false });
    },
    data() {
        return {
            tagGroups: [],
            cols: [
                { key: 'id', heading: 'ID', size: 3, },
                { key: 'name', heading: 'Title', sortable: true, size: 9 },
            ],
            loading: true,
            submitting: false,
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                search: '',
            }
        }
    },
    methods: {
        fetchTagGroups() {
            this.submitting = true

            return this.$cfetch(`${this.$settings.APIBaseURL}/tags/groups/list`, {
                method: 'POST',
                data: this.filters,
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching tag groups')

                this.tagGroups = res.results
                this.filters.page = res.pagination.page
                this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t("unexpected-error-fetching-tag-groups"),
                    confirmCallBack: function () {
                        this.$router.push('/settings')
                    }
                })
            }).finally(() => {
                this.submitting = false
            })
        }
    }
}

</script>